import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearUpdateRecordError,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    clearAddRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfLists,
    updateInLists,
    removeFromLists,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LOCATION_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_LOCATION_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_LOCATION_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_LOCATION_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_LOCATION_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_LOCATION_LIST: return addToBottomOfLists(state, action.payload);
        case actionTypes.UPDATE_IN_LOCATION_LIST: return updateInLists(state, action.payload);
        case actionTypes.REMOVE_FROM_LOCATION_LIST: return removeFromLists(state, action.payload);
        case actionTypes.FETCH_LOCATION_START: return fetchRecordStart(state);
        case actionTypes.FETCH_LOCATION_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_LOCATION_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_LOCATION: return clearRecord(state);
        case actionTypes.ADD_LOCATION: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_LOCATION_START: return addRecordStart(state);
        case actionTypes.ADD_LOCATION_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_LOCATION_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_LOCATION_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_LOCATION_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_LOCATION_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_LOCATION: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_LOCATION: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_LOCATION_START: return updateRecordStart(state);
        case actionTypes.UPDATE_LOCATION_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_LOCATION_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_LOCATION_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_LOCATION_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_LOCATION_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_LOCATION: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;